import { render, staticRenderFns } from "./Spinners.vue?vue&type=template&id=e87b481c&scoped=true"
import script from "./Spinners.vue?vue&type=script&lang=ts"
export * from "./Spinners.vue?vue&type=script&lang=ts"
import style0 from "./Spinners.vue?vue&type=style&index=0&id=e87b481c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87b481c",
  null
  
)

export default component.exports